import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'squirrel',
      d: 'M-1,-3h0.5v0.5h-0.5zM1.5,-3h1.5v1h-1.5zM-1.5,-2.5h2v0.5h-2zM-1.5,-2h0.5v0.5h-0.5zM-0.5,-2h1v0.5h-1zM1,-2h2v0.5h-2zM-0.5,-1.5h3v0.5h-3zM-1,-1h0.5v1h-0.5zM0,-1h2v0.5h-2zM0,-0.5h1v0.5h-1zM-0.5,0h1v0.5h-1z',
    },
    {
      paint: 'fence',
      d: 'M1,-4h1v0.5h-1zM0.5,-3.5h2v0.5h-2zM0.5,-3h1v0.5h-1zM-1,-1.5h0.5v0.5h-0.5zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'mushroom', d: 'M-1,-2h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5z' },
  ],
  pixels: 46,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
